import {
  aCustomMatchListColumn,
  mockCustomMatchListColumnsOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const CUSTOM_MATCH_LIST_COLUMN_DATA = {
  fields: ['action', 'application'],
  name: `Test Custom Column ${Date.now()}`,
  updatedName: `Test Custom Column Updated ${Date.now()}`,
  updatedFields: ['action', 'baseImage'],
};

export const customMatchListColumnHandler = ({ id, fields, name }) => ({
  __typename: 'Query',
  customMatchListColumns: [
    aCustomMatchListColumn({
      id,
      fields,
      name,
    }),
  ],
  customMatchListColumnLimit: 5,
});

export const handlers = [
  mockCustomMatchListColumnsOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          customMatchListColumns: [],
          customMatchListColumnLimit: 5,
        },
      });
    }
  ),
];
